(function() {
    'use strict';

    angular.module('app').controller('CloneMarginModalController', CloneMarginModalController);
    CloneMarginModalController.$inject = [
        'ServicesService',
        'marginData',
        'toastr',
        '$uibModalInstance'
    ];

    function CloneMarginModalController(
        ServicesService,
        marginData,
        toastr,
        $uibModalInstance
    ) {
        const vm = this;
        vm.isLoading = false;

        vm.onSubmit = onSubmit;
        vm.closeModal = closeModal;

        init();

        function init() {
            setDefaultCloneMarginName();
        }

        function setDefaultCloneMarginName() {
            vm.name = `CLONE - ${marginData.name}`;
        }

        function onSubmit(form) {
            if (form.$invalid) {
                form.$setSubmitted();
                return;
            }

            cloneMargin();
        }

        function cloneMargin() {
            vm.isLoading = true;
            ServicesService.cloneMargin(marginData.id, success => {
                toastr.success('Successfully cloned', 'Success!');
                vm.isLoading = false;
                $uibModalInstance.close();
            }, error => {
                vm.isLoading = false;
                toastr.error(error.message, 'Error!');
            }, {name: vm.name })
        }

        function closeModal() {
            $uibModalInstance.close();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/services/modals/CloneMarginModalController.js